import type { ToolTestSourceResponse } from '@reach/shared-types/tool-test-result';
import { CopyButton } from './CopyButton';
import styles from './ToolTestResult.module.css';

interface ToolTestSourceResponsePaneProps {
  sourceResponse: ToolTestSourceResponse;
}

const SOURCE_RESPONSE_TITLE = "Your API's response";

const badgeClassForHttpStatus = (httpStatus: number): string => {
  if (httpStatus >= 500) return styles.errorBadge;
  if (httpStatus >= 400) return styles.warningBadge;
  return styles.successBadge;
};

export const ToolTestSourceResponsePane = ({ sourceResponse }: ToolTestSourceResponsePaneProps) => {
  const sourceText = JSON.stringify(sourceResponse.body, null, 2);
  const badgeClass = badgeClassForHttpStatus(sourceResponse.httpStatus);

  return (
    <>
      <header className={styles.cardHeader}>
        <div className={styles.statusGroup}>
          <span className={styles.cardTitle}>{SOURCE_RESPONSE_TITLE}</span>
          <span className={badgeClass}>HTTP {sourceResponse.httpStatus}</span>
        </div>
        <CopyButton value={sourceText} />
      </header>
      <pre className={styles.code}>{sourceText}</pre>
    </>
  );
};
